import { Cart, StateUtils } from '@spartacus/core';
import { CartActions } from '../actions';

export const activeCartInitialState = null;
export const activeCartDefaultState = '';

export function activeCartReducer(
  state = activeCartDefaultState,
  action: CartActions.CartAction | CartActions.MultiCartActions,
): string {
  switch (action.type) {
    case CartActions.LOAD_CART_SUCCESS:
    case CartActions.CREATE_CART_SUCCESS:
    case CartActions.CREATE_CART:
      // point to `temp-${uuid}` cart when we are creating/merging cart
      if (action?.payload?.extraData?.active) {
        return action.meta.entityId as string;
      } else {
        return state;
      }
    case CartActions.SET_ACTIVE_CART_ID:
      return action.payload;
    case CartActions.REMOVE_CART:
    case CartActions.DELETE_CART_SUCCESS:
      if (action.payload?.cartId === state) {
        return activeCartDefaultState;
      }

      return state;
    case CartActions.CLEAR_CART_STATE:
      return state === activeCartInitialState ? activeCartInitialState : activeCartDefaultState;
  }

  return state;
}

export const cartEntitiesInitialState = undefined;

export function cartEntitiesReducer(state = cartEntitiesInitialState, action: StateUtils.LoaderAction): Cart {
  switch (action.type) {
    case CartActions.LOAD_CARTS_SUCCESS:
      return action.payload;

    case CartActions.LOAD_CART_SUCCESS:
    case CartActions.CREATE_CART_SUCCESS:
    case CartActions.SET_TEMP_CART:
      return action.payload.cart;
  }

  return state;
}
